var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPasswordSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm5.575 6.665L9.42 13.588a.77.77 0 0 1-1.056.09L4.52 10.6a.77.77 0 0 1-.12-1.081.77.77 0 0 1 1.081-.12l3.276 2.62 5.67-6.377a.77.77 0 0 1 1.086-.064.77.77 0 0 1 .064 1.087z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "media/abfb9b5e.svg";
export { SvgPasswordSuccess as ReactComponent };